module.exports = __webpack_public_path__ + "img/zip.31163533.png";